import { useMemo } from "react";

interface UseOptionsProps {
	isClientPreview: boolean;
	fieldValue?: string[];
	previewQuestion?: {
		fields?: { option?: string[] } | string[];
	};
}

interface Option {
	label: string;
	value: string;
}

export const useOptions = ({
	isClientPreview,
	fieldValue,
	previewQuestion,
}: UseOptionsProps): Option[] => {
	const getOptions = (values?: string[]): Option[] => {
		return (
			values?.map((item, i) => ({
				label: item,
				value: i.toString(),
			})) ?? []
		);
	};

	const extractValues = (
		fields?: { option?: string[] } | string[]
	): string[] => {
		if (Array.isArray(fields)) return fields; // direct array
		if (fields && "option" in fields && Array.isArray(fields.option))
			return fields.option;
		return [];
	};

	return useMemo(() => {
		const values = isClientPreview
			? extractValues(previewQuestion?.fields)
			: fieldValue;

		return getOptions(values);
	}, [isClientPreview, fieldValue, previewQuestion]);
};
